export var themes = {
  error: 'error',
  white: 'white',
  dark: 'dark'
};